import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { SCREEN_SIZE, STYLES } from '../../../../style';
import { Link } from '../../../shared/Link';

const StyledBusinessNavigationListItem = styled.div`
  background-color: ${({ color }) => color};
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 1rem;
  margin: 1rem 0;
  ${SCREEN_SIZE.LG} {
    position: relative;
    margin: 0 .5rem;
  }
`;

const BusinessNavigationTitle = styled.div`
  color: ${STYLES.COLOR_WHITE};
  font-size: ${STYLES.FONT_SIZE_SM};
  margin-bottom: 1rem;
`;

const BusinessNavigationImage = styled.img`
  display: block;
  margin: 0 auto;
`;

const BusinessNavigationLink = styled(Link)`
  text-transform: uppercase;
  color: ${STYLES.COLOR_WHITE};
  border: 1px solid ${STYLES.COLOR_WHITE};
  border-radius: 3px;
  padding: .5rem 1rem;
  margin-top: 1rem;
  .no-touch &:hover {
    color: ${STYLES.COLOR_WHITE};
  }
`;

const ImageContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const ActiveBorder = styled.div`
  display: none;
  ${SCREEN_SIZE.LG} {
    display: block;
    position: absolute;
    height: .5rem;
    background-color: ${({ color }) => color};
    transform: translateY(1rem);
    left: 1rem;
    right: 1rem;
    bottom: 0;
  }
`;

const BusinessNavigationListItem = ({
  data: {
    title,
    image,
    color,
    url,
    active,
  },
}) => {
  return (
    <StyledBusinessNavigationListItem color={color} active={active}>
      <BusinessNavigationTitle>{title}</BusinessNavigationTitle>
      <ImageContainer>
        <BusinessNavigationImage
          src={image}
        />
      </ImageContainer>
      <BusinessNavigationLink to={url}>Learn more</BusinessNavigationLink>
      { active && <ActiveBorder color={color} /> }
    </StyledBusinessNavigationListItem>
  );
};

BusinessNavigationListItem.propTypes = {
  // eslint-disable-next-line
  data: PropTypes.object.isRequired,
};

export { BusinessNavigationListItem };